<template>
    <div class="card not-word-wrap mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="customerId || $store.state.userData.isOrganization">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12">
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" @click="setChargeType('single')" data-toggle="tab" href="#single">شارژ تکی بن کارت</a>
                        <a class="nav-link" @click="setChargeType('multi')" data-toggle="tab" href="#multi">شارژ گروهی بن کارت</a>
                    </nav>
                    <div class="tab-content">
                        <form class="tab-pane active show" id="single" v-on:submit.prevent="submit">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شماره کارت</label>
                                        <input type="tel" class="form-control text-center" v-mask="'####-####-####-####'" v-model="pan" dir="ltr" style="direction: ltr !important">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>نام</label>
                                        <input type="text" class="form-control" v-model="firstName">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>نام خانوادگی</label>
                                        <input type="text" class="form-control" v-model="lastName">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>شماره گذرنامه</label>
                                        <input type="text" class="form-control ltr-input" maxlength="20" v-model="passportNumber">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>مبلغ شارژ (ریال)</label>
                                        <input type="tel" class="form-control ltr-input" @keyup="e => changeDeposit(e)" v-model="deposit">
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <label>شماره همراه</label>
                                        </div>
                                        <div class="col-md-4">
                                            <label>کد کشور</label>
                                        </div>
                                    </div>
                                    <div class="input-group mb-3">
                                        <input type="tel" v-model="mobile" class="form-control ltr-input" maxlength="10">
                                        <div class="input-group-append">
                                            <select class="custom-select" v-model="countryCode">
                                                <option v-for="(country,index) in countriesList" :key="index" :value="country.code" v-html="country.country + ' ' + country.code"></option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-success">ثبت درخواست</button>
                                </div>
                            </div>
                        </form>
                        <div class="tab-pane" id="multi">
                            <div class="row">
                                <div class="col-md-4">
                                    <label>انتخاب فایل شارژ</label>
                                    <div class="input-group file-browser">
                                        <input type="text" class="form-control border-left-0 browse-file" id="contract-file" placeholder="آپلود فایل" readonly="">
                                        <label class="input-group-btn mb-0">
                                            <span class="btn btn-primary">
                                                انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setExcelFile">
                                            </span>
                                        </label>
                                    </div>
                                    <p class="mt-3 mb-0">
                                        <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                                    </p>
                                </div>
                                <div class="col-md-4" v-if="false">
                                    <div class="form-group">
                                        <label>میزان تخفیف</label>
                                        <input type="tel" class="form-control ltr-input" @keyup="e => changeCustomDepositValue(e)" v-model="discount">
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2">
                                    <button class="btn btn-success" v-if="file" @click="submit">ثبت درخواست</button>
                                    <button class="btn btn-primary mr-2" v-if="resultFile" @click="getResultExcelFile">دریافت فایل نتیجه</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="domain">سازمان</label>
                        <Vselect @input="searchCustomer" v-model="nationalCode" :reduce="item => item.nationalId" label="title" :options="organizations">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Charge',
    data(){
        return {
            resultFile: '',
            showLoading: false,
            legalCustomerDetails: {},
            nationalCode: '',
            file: '',
            deposit: '',
            discount: 0,
            pan: '',
            firstName: '',
            lastName: '',
            passportNumber: '',
            mobile: '',
            organizations: [],
            chargeType: '',
            customerId: 0,
            countryEmojie: "🇮🇷",
            countryCode: "+98",
            countriesList: [
                {
                    code: '+1',
                    country: "🇺🇸"
                },
                {
                    code: '+1242',
                    country: "🇧🇸"
                },
                {
                    code: '+1246',
                    country: "🇧🇧"
                },
                {
                    code: '+1264',
                    country: "🇦🇮"
                },
                {
                    code: '+1268',
                    country: "🇦🇬"
                },
                {
                    code: '+1284',
                    country: "🇻🇬"
                },
                {
                    code: '+1340',
                    country: "🇻🇮"
                },
                {
                    code: '+1441',
                    country: "🇧🇲"
                },
                {
                    code: '+1473',
                    country: "🇬🇩"
                },
                {
                    code: '+1649',
                    country: "🇹🇨"
                },
                {
                    code: '+1664',
                    country: "🇲🇸"
                },
                {
                    code: '+1670',
                    country: "🇲🇵"
                },
                {
                    code: '+1671',
                    country: "🇬🇺"
                },
                {
                    code: '+1684',
                    country: "🇦🇸"
                },
                {
                    code: '+1758',
                    country: "🇱🇨"
                },
                {
                    code: '+1767',
                    country: "🇩🇲"
                },
                {
                    code: '+1784',
                    country: "🇻🇨"
                },
                {
                    code: '+1849',
                    country: "🇩🇴"
                },
                {
                    code: '+1868',
                    country: "🇹🇹"
                },
                {
                    code: '+1869',
                    country: "🇰🇳"
                },
                {
                    code: '+1876',
                    country: "🇯🇲"
                },
                {
                    code: '+1939',
                    country: "🇵🇷"
                },
                {
                    code: '+20',
                    country: "🇪🇬"
                },
                {
                    code: '+211',
                    country: "🇸🇸"
                },
                {
                    code: '+212',
                    country: "🇲🇦"
                },
                {
                    code: '+213',
                    country: "🇩🇿"
                },
                {
                    code: '+216',
                    country: "🇹🇳"
                },
                {
                    code: '+218',
                    country: "🇱🇾"
                },
                {
                    code: '+220',
                    country: "🇬🇲"
                },
                {
                    code: '+221',
                    country: "🇸🇳"
                },
                {
                    code: '+222',
                    country: "🇲🇷"
                },
                {
                    code: '+223',
                    country: "🇲🇱"
                },
                {
                    code: '+224',
                    country: "🇬🇳"
                },
                {
                    code: '+225',
                    country: "🇨🇮"
                },
                {
                    code: '+226',
                    country: "🇧🇫"
                },
                {
                    code: '+227',
                    country: "🇳🇪"
                },
                {
                    code: '+228',
                    country: "🇹🇬"
                },
                {
                    code: '+229',
                    country: "🇧🇯"
                },
                {
                    code: '+230',
                    country: "🇲🇺"
                },
                {
                    code: '+231',
                    country: "🇱🇷"
                },
                {
                    code: '+232',
                    country: "🇸🇱"
                },
                {
                    code: '+233',
                    country: "🇬🇭"
                },
                {
                    code: '+234',
                    country: "🇳🇬"
                },
                {
                    code: '+235',
                    country: "🇹🇩"
                },
                {
                    code: '+236',
                    country: "🇨🇫"
                },
                {
                    code: '+237',
                    country: "🇨🇲"
                },
                {
                    code: '+238',
                    country: "🇨🇻"
                },
                {
                    code: '+239',
                    country: "🇸🇹"
                },
                {
                    code: '+240',
                    country: "🇬🇶"
                },
                {
                    code: '+241',
                    country: "🇬🇦"
                },
                {
                    code: '+242',
                    country: "🇨🇬"
                },
                {
                    code: '+243',
                    country: "🇨🇩"
                },
                {
                    code: '+244',
                    country: "🇦🇴"
                },
                {
                    code: '+245',
                    country: "🇬🇼"
                },
                {
                    code: '+246',
                    country: "🇮🇴"
                },
                {
                    code: '+248',
                    country: "🇸🇨"
                },
                {
                    code: '+249',
                    country: "🇸🇩"
                },
                {
                    code: '+250',
                    country: "🇷🇼"
                },
                {
                    code: '+251',
                    country: "🇪🇹"
                },
                {
                    code: '+252',
                    country: "🇸🇴"
                },
                {
                    code: '+253',
                    country: "🇩🇯"
                },
                {
                    code: '+254',
                    country: "🇰🇪"
                },
                {
                    code: '+255',
                    country: "🇹🇿"
                },
                {
                    code: '+256',
                    country: "🇺🇬"
                },
                {
                    code: '+257',
                    country: "🇧🇮"
                },
                {
                    code: '+258',
                    country: "🇲🇿"
                },
                {
                    code: '+260',
                    country: "🇿🇲"
                },
                {
                    code: '+261',
                    country: "🇲🇬"
                },
                {
                    code: '+262',
                    country: "🇹🇫"
                },
                {
                    code: '+262',
                    country: "🇾🇹"
                },
                {
                    code: '+262',
                    country: "🇷🇪"
                },
                {
                    code: '+263',
                    country: "🇿🇼"
                },
                {
                    code: '+264',
                    country: "🇳🇦"
                },
                {
                    code: '+265',
                    country: "🇲🇼"
                },
                {
                    code: '+266',
                    country: "🇱🇸"
                },
                {
                    code: '+267',
                    country: "🇧🇼"
                },
                {
                    code: '+268',
                    country: "🇸🇿"
                },
                {
                    code: '+269',
                    country: "🇰🇲"
                },
                {
                    code: '+27',
                    country: "🇿🇦"
                },
                {
                    code: '+290',
                    country: "🇸🇭"
                },
                {
                    code: '+291',
                    country: "🇪🇷"
                },
                {
                    code: '+297',
                    country: "🇦🇼"
                },
                {
                    code: '+298',
                    country: "🇫🇴"
                },
                {
                    code: '+299',
                    country: "🇬🇱"
                },
                {
                    code: '+30',
                    country: "🇬🇷"
                },
                {
                    code: '+31',
                    country: "🇳🇱"
                },
                {
                    code: '+32',
                    country: "🇧🇪"
                },
                {
                    code: '+33',
                    country: "🇫🇷"
                },
                {
                    code: '+34',
                    country: "🇪🇸"
                },
                {
                    code: '+345',
                    country: "🇰🇾"
                },
                {
                    code: '+350',
                    country: "🇬🇮"
                },
                {
                    code: '+351',
                    country: "🇵🇹"
                },
                {
                    code: '+352',
                    country: "🇱🇺"
                },
                {
                    code: '+353',
                    country: "🇮🇪"
                },
                {
                    code: '+354',
                    country: "🇮🇸"
                },
                {
                    code: '+355',
                    country: "🇦🇱"
                },
                {
                    code: '+356',
                    country: "🇲🇹"
                },
                {
                    code: '+357',
                    country: "🇨🇾"
                },
                {
                    code: '+358',
                    country: "🇦🇽"
                },
                {
                    code: '+358',
                    country: "🇫🇮"
                },
                {
                    code: '+359',
                    country: "🇧🇬"
                },
                {
                    code: '+36',
                    country: "🇭🇺"
                },
                {
                    code: '+370',
                    country: "🇱🇹"
                },
                {
                    code: '+371',
                    country: "🇱🇻"
                },
                {
                    code: '+372',
                    country: "🇪🇪"
                },
                {
                    code: '+373',
                    country: "🇲🇩"
                },
                {
                    code: '+374',
                    country: "🇦🇲"
                },
                {
                    code: '+375',
                    country: "🇧🇾"
                },
                {
                    code: '+376',
                    country: "🇦🇩"
                },
                {
                    code: '+377',
                    country: "🇲🇨"
                },
                {
                    code: '+378',
                    country: "🇸🇲"
                },
                {
                    code: '+379',
                    country: "🇻🇦"
                },
                {
                    code: '+380',
                    country: "🇺🇦"
                },
                {
                    code: '+381',
                    country: "🇷🇸"
                },
                {
                    code: '+382',
                    country: "🇲🇪"
                },
                {
                    code: '+383',
                    country: "🇽🇰"
                },
                {
                    code: '+385',
                    country: "🇭🇷"
                },
                {
                    code: '+386',
                    country: "🇸🇮"
                },
                {
                    code: '+387',
                    country: "🇧🇦"
                },
                {
                    code: '+389',
                    country: "🇲🇰"
                },
                {
                    code: '+39',
                    country: "🇮🇹"
                },
                {
                    code: '+40',
                    country: "🇷🇴"
                },
                {
                    code: '+41',
                    country: "🇨🇭"
                },
                {
                    code: '+420',
                    country: "🇨🇿"
                },
                {
                    code: '+421',
                    country: "🇸🇰"
                },
                {
                    code: '+423',
                    country: "🇱🇮"
                },
                {
                    code: '+43',
                    country: "🇦🇹"
                },
                {
                    code: '+44',
                    country: "🇬🇬"
                },
                {
                    code: '+44',
                    country: "🇮🇲"
                },
                {
                    code: '+44',
                    country: "🇯🇪"
                },
                {
                    code: '+44',
                    country: "🇬🇧"
                },
                {
                    code: '+45',
                    country: "🇩🇰"
                },
                {
                    code: '+46',
                    country: "🇸🇪"
                },
                {
                    code: '+47',
                    country: "🇧🇻"
                },
                {
                    code: '+47',
                    country: "🇳🇴"
                },
                {
                    code: '+47',
                    country: "🇸🇯"
                },
                {
                    code: '+48',
                    country: "🇵🇱"
                },
                {
                    code: '+49',
                    country: "🇩🇪"
                },
                {
                    code: '+500',
                    country: "🇫🇰"
                },
                {
                    code: '+500',
                    country: "🇬🇸"
                },
                {
                    code: '+501',
                    country: "🇧🇿"
                },
                {
                    code: '+502',
                    country: "🇬🇹"
                },
                {
                    code: '+503',
                    country: "🇸🇻"
                },
                {
                    code: '+504',
                    country: "🇭🇳"
                },
                {
                    code: '+505',
                    country: "🇳🇮"
                },
                {
                    code: '+506',
                    country: "🇨🇷"
                },
                {
                    code: '+507',
                    country: "🇵🇦"
                },
                {
                    code: '+508',
                    country: "🇵🇲"
                },
                {
                    code: '+509',
                    country: "🇭🇹"
                },
                {
                    code: '+51',
                    country: "🇵🇪"
                },
                {
                    code: '+52',
                    country: "🇲🇽"
                },
                {
                    code: '+53',
                    country: "🇨🇺"
                },
                {
                    code: '+54',
                    country: "🇦🇷"
                },
                {
                    code: '+55',
                    country: "🇧🇷"
                },
                {
                    code: '+56',
                    country: "🇨🇱"
                },
                {
                    code: '+57',
                    country: "🇨🇴"
                },
                {
                    code: '+58',
                    country: "🇻🇪"
                },
                {
                    code: '+590',
                    country: "🇬🇵"
                },
                {
                    code: '+590',
                    country: "🇧🇱"
                },
                {
                    code: '+590',
                    country: "🇲🇫"
                },
                {
                    code: '+591',
                    country: "🇧🇴"
                },
                {
                    code: '+592',
                    country: "🇬🇾"
                },
                {
                    code: '+593',
                    country: "🇪🇨"
                },
                {
                    code: '+594',
                    country: "🇬🇫"
                },
                {
                    code: '+595',
                    country: "🇵🇾"
                },
                {
                    code: '+596',
                    country: "🇲🇶"
                },
                {
                    code: '+597',
                    country: "🇸🇷"
                },
                {
                    code: '+598',
                    country: "🇺🇾"
                },
                {
                    code: '+60',
                    country: "🇲🇾"
                },
                {
                    code: '+61',
                    country: "🇦🇺"
                },
                {
                    code: '+61',
                    country: "🇨🇽"
                },
                {
                    code: '+61',
                    country: "🇨🇨"
                },
                {
                    code: '+62',
                    country: "🇮🇩"
                },
                {
                    code: '+63',
                    country: "🇵🇭"
                },
                {
                    code: '+64',
                    country: "🇳🇿"
                },
                {
                    code: '+64',
                    country: "🇵🇳"
                },
                {
                    code: '+65',
                    country: "🇸🇬"
                },
                {
                    code: '+66',
                    country: "🇹🇭"
                },
                {
                    code: '+670',
                    country: "🇹🇱"
                },
                {
                    code: '+672',
                    country: "🇦🇶"
                },
                {
                    code: '+672',
                    country: "🇭🇲"
                },
                {
                    code: '+672',
                    country: "🇳🇫"
                },
                {
                    code: '+673',
                    country: "🇧🇳"
                },
                {
                    code: '+674',
                    country: "🇳🇷"
                },
                {
                    code: '+675',
                    country: "🇵🇬"
                },
                {
                    code: '+676',
                    country: "🇹🇴"
                },
                {
                    code: '+677',
                    country: "🇸🇧"
                },
                {
                    code: '+678',
                    country: "🇻🇺"
                },
                {
                    code: '+679',
                    country: "🇫🇯"
                },
                {
                    code: '+680',
                    country: "🇵🇼"
                },
                {
                    code: '+681',
                    country: "🇼🇫"
                },
                {
                    code: '+682',
                    country: "🇨🇰"
                },
                {
                    code: '+683',
                    country: "🇳🇺"
                },
                {
                    code: '+685',
                    country: "🇼🇸"
                },
                {
                    code: '+686',
                    country: "🇰🇮"
                },
                {
                    code: '+687',
                    country: "🇳🇨"
                },
                {
                    code: '+688',
                    country: "🇹🇻"
                },
                {
                    code: '+689',
                    country: "🇵🇫"
                },
                {
                    code: '+690',
                    country: "🇹🇰"
                },
                {
                    code: '+691',
                    country: "🇫🇲"
                },
                {
                    code: '+692',
                    country: "🇲🇭"
                },
                {
                    code: '+7',
                    country: "🇰🇿"
                },
                {
                    code: '+7',
                    country: "🇷🇺"
                },
                {
                    code: '+81',
                    country: "🇯🇵"
                },
                {
                    code: '+82',
                    country: "🇰🇷"
                },
                {
                    code: '+84',
                    country: "🇻🇳"
                },
                {
                    code: '+850',
                    country: "🇰🇵"
                },
                {
                    code: '+852',
                    country: "🇭🇰"
                },
                {
                    code: '+853',
                    country: "🇲🇴"
                },
                {
                    code: '+855',
                    country: "🇰🇭"
                },
                {
                    code: '+856',
                    country: "🇱🇦"
                },
                {
                    code: '+86',
                    country: "🇨🇳"
                },
                {
                    code: '+880',
                    country: "🇧🇩"
                },
                {
                    code: '+886',
                    country: "🇹🇼"
                },
                {
                    code: '+90',
                    country: "🇹🇷"
                },
                {
                    code: '+91',
                    country: "🇮🇳"
                },
                {
                    code: '+92',
                    country: "🇵🇰"
                },
                {
                    code: '+93',
                    country: "🇦🇫"
                },
                {
                    code: '+94',
                    country: "🇱🇰"
                },
                {
                    code: '+95',
                    country: "🇲🇲"
                },
                {
                    code: '+960',
                    country: "🇲🇻"
                },
                {
                    code: '+961',
                    country: "🇱🇧"
                },
                {
                    code: '+962',
                    country: "🇯🇴"
                },
                {
                    code: '+963',
                    country: "🇸🇾"
                },
                {
                    code: '+964',
                    country: "🇮🇶"
                },
                {
                    code: '+965',
                    country: "🇰🇼"
                },
                {
                    code: '+966',
                    country: "🇸🇦"
                },
                {
                    code: '+967',
                    country: "🇾🇪"
                },
                {
                    code: '+968',
                    country: "🇴🇲"
                },
                {
                    code: '+970',
                    country: "🇵🇸"
                },
                {
                    code: '+971',
                    country: "🇦🇪"
                },
                {
                    code: '+972',
                    country: "🇮🇱"
                },
                {
                    code: '+973',
                    country: "🇧🇭"
                },
                {
                    code: '+974',
                    country: "🇶🇦"
                },
                {
                    code: '+975',
                    country: "🇧🇹"
                },
                {
                    code: '+976',
                    country: "🇲🇳"
                },
                {
                    code: '+977',
                    country: "🇳🇵"
                },
                {
                    code: '+98',
                    country: "🇮🇷"
                },
                {
                    code: '+992',
                    country: "🇹🇯"
                },
                {
                    code: '+993',
                    country: "🇹🇲"
                },
                {
                    code: '+994',
                    country: "🇦🇿"
                },
                {
                    code: '+995',
                    country: "🇬🇪"
                },
                {
                    code: '+996',
                    country: "🇰🇬"
                },
                {
                    code: '+998',
                    country: "🇺🇿"
                }
            ]
        }
    },
    methods: {
        getData(){
            const postedData = {
                page: 1,
                perPage: 500
            };
            this.$api.post('Management/organizations/List',postedData).then(({data}) => {
                let organizations = [];
                data.result.list.map(item => {
                    organizations.push({
                        title: item.domainMetaData.companyNameFa,
                        nationalId: item.domainMetaData.nationalId
                    });
                });
                this.organizations = organizations;
            });
        },
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status)
                    this.legalCustomerDetails = data.result;
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Bonus/Charge/Sample1').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            this.resultFile = '';
            document.getElementById('contract-file').setAttribute('placeholder',file.name);
        },
        changeDeposit(e){
            let value = this.deposit ? this.deposit.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value))
                e.preventDefault();
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.deposit = value;
        },
        changeCustomDepositValue(e){
            let value = this.discount ? this.discount.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.discount = value;
        },
        getResultExcelFile(){
            let a = window.document.createElement('a');
            a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + this.resultFile);
            let fileName = this.resultFile;
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        setChargeType(chargeType){
            this.chargeType = chargeType;
        },
        submit(){
            this.showLoading = true;
            let postedData = {};
            if(this.chargeType == 'multi'){
                postedData = {
                    file: this.file,
                    tourism: true,
                    discount: parseInt(this.discount.toString().replace(/,/g,''))
                };
            }else{
                postedData = {
                    discount: 0,
                    tourism: true,
                    chargeRequest: [
                        {
                            pan: this.pan.replace(/-/g,''),
                            firstName: this.firstName,
                            lastName: this.lastName,
                            passportNumber: this.passportNumber,
                            mobile: this.countryCode + '' + this.mobile.replace(/-/g,''),
                            charge: this.deposit.replace(/,/g,'')
                        }
                    ]
                };
            }
            if(this.customerId)
                postedData['domainDataId'] = this.customerId;
            this.$api.post('Organizations/Bonus/Charge',postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.fileString : '';
                if(data.status)
                    this.$swal({
                        icon: 'success',
                        title: 'تبریک !',
                        text: 'ثبت درخواست شارژ با موفقیت انجام شد',
                    }).then(res => {
                        if(res.isConfirmed){
                            this.$router.push({name: 'foreignBonusCards.index'});
                        }
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        }
    },
    created(){
        this.getData();
    }
}
</script>